import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faShapes,
  faCrosshairs,
  faHandPointer,
  faGameBoardAlt,
  faGameBoard,
  faRulerTriangle,
  faTh,
  faBookmark,
  faLink,
  faCode,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faArrows,
  faSyncAlt,
  faBackwardStep,
  faForwardStep,
  faForward,
  faBackward,
  faRepeat,
  faRepeat1,
  faLock,
  faLockOpen,
  faEllipsis,
  faEllipsisV,
  faCaretUp,
  faCaretRight,
  faCaretDown,
  faCaretLeft,
  faCaretSquareDown,
  faAngleUp,
  faAngleDown,
  faLevelDownAlt,
  faPlay,
  faPause,
  faSquare,
  faVolumeUp,
  faVolumeMute,
  faExpand,
  faCompress,
  faGear,
  faShare,
  faArchive,
  faExchangeAlt,
  faUsersCog,
  faPlane,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faArrowDown,
  faArrowDownToLine,
  faArrowToRight,
  faArrowAltFromLeft,
  faArrowAltFromRight,
  faArrowAltToLeft,
  faArrowAltToRight,
  faArrowRightArrowLeft,
  faPlus,
  faUserPlus,
  faPlusSquare,
  faMinusSquare,
  faMinusCircle,
  faPenToSquare,
  faUser,
  faSignOutAlt,
  faBell,
  faCircleQuestion,
  faQuestion,
  faPencil,
  faVideo,
  faImage,
  faPhotoVideo,
  faCameraMovie,
  faFile,
  faFileAudio,
  faFileVideo,
  faFileArchive,
  faFileImage,
  faFileImport,
  faFileUpload,
  faFilm,
  faCube,
  faLayerGroup,
  faUnlock,
  faEye,
  faTrashAlt,
  faComment,
  faTriangleExclamation,
  faCircleExclamation,
  faSpinner,
  faCircleNotch,
  faCheck,
  faCircleCheck,
  faUsers,
  faUserFriends,
  faCircle,
  faExpandWide,
  faCompressWide,
  faGripLinesVertical,
  faGripHorizontal,
  faList,
  faIndent,
  faLightbulbOn,
  faLightbulb,
  faEyeSlash,
  faBars,
  faXmark,
  faClock,
  faComments,
  faFolder,
  faFolders,
  faFolderOpen,
  faFolderPlus,
  faCreditCardFront,
  faMagnifyingGlass,
  faLayerPlus,
  faUpload,
  faLevelDown,
  faLevelUp,
  faDeleteLeft,
  faDiamond,
  faCircleInfo,
  faSort,
  faDotCircle,
  faBolt,
  faInboxIn,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faHouse,
  faExchange,
  faBuilding,
  faCar,
  faCalendarAlt,
  faFlag,
  faGlobeAmericas,
  faPresentation,
  faCubes,
  faAlignLeft,
  faTheaterMasks,
  faTv,
  faMusic,
  faGlobe,
  faGlobeEurope,
  faCopy,
  faCreditCard,
  faMousePointer,
  faExpandArrows,
  faSlidersVSquare,
  faMap,
  faArrowUpRightFromSquare,
  faWaveform,
  faEnvelope,
  faBorderAll,
  faCloudUpload,
  faListAlt,
  faBarsStaggered,
  faHardDrive,
  faShuffle,
  faICursor
} from '@fortawesome/pro-solid-svg-icons'

import {
  faDropbox,
  faGoogleDrive,
  faDev,
  faSlack
} from '@fortawesome/free-brands-svg-icons'

import {
  faDiamond as farDiamond,
  faAngleDoubleLeft as farAngleDoubleLeft,
  faCube as farCube,
  faFrown as farFrown,
  faGlobe as farGlobe,
  faCheckSquare as farCheckSquare,
  faCreditCard as farCreditCard,
  faSlidersVSquare as farSlidersVSquare,
  faHeart as farHeart
} from '@fortawesome/pro-regular-svg-icons'

import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons'

library.add(
  faShapes,
  faArrowUpRightFromSquare,
  faCrosshairs,
  faHandPointer,
  faGameBoardAlt,
  faGameBoard,
  faRulerTriangle,
  faTh,
  faBookmark,
  faLink,
  faCode,
  faGlobe,
  faGlobeEurope,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faArrows,
  faSyncAlt,
  faForward,
  faBackward,
  faForwardStep,
  faBackwardStep,
  faRepeat,
  faRepeat1,
  faSlack,
  faDev,
  faHouse,
  faLock,
  faLockOpen,
  faEllipsis,
  faEllipsisV,
  faCaretUp,
  faCaretRight,
  faCaretDown,
  faCaretLeft,
  faCaretSquareDown,
  faAngleUp,
  faAngleDown,
  faLevelDownAlt,
  faPlay,
  faPause,
  faSquare,
  faVolumeUp,
  faVolumeMute,
  faExpand,
  faCompress,
  faGear,
  faShare,
  faArchive,
  faExchangeAlt,
  faUsersCog,
  faPlane,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faArrowDown,
  faArrowDownToLine,
  faArrowToRight,
  faArrowAltFromLeft,
  faArrowAltFromRight,
  faArrowAltToLeft,
  faArrowAltToRight,
  faArrowRightArrowLeft,
  faPlus,
  faUserPlus,
  faPlusSquare,
  faMinusSquare,
  faMinusCircle,
  faPenToSquare,
  faUser,
  faSignOutAlt,
  faBell,
  faCircleQuestion,
  faQuestion,
  faPencil,
  faVideo,
  faImage,
  faPhotoVideo,
  faCameraMovie,
  faFile,
  faFileAudio,
  faFileVideo,
  faFileArchive,
  faFileImage,
  faFileImport,
  faFileUpload,
  faFilm,
  faCube,
  faLayerGroup,
  faUnlock,
  faEye,
  faEyeSlash,
  faTrashAlt,
  faComment,
  faTriangleExclamation,
  faCircleExclamation,
  faSpinner,
  fadSpinnerThird,
  faCircleNotch,
  faCheck,
  faCircleCheck,
  farCheckSquare,
  farCreditCard,
  faUsers,
  faUserFriends,
  faExpandWide,
  faCompressWide,
  faGripLinesVertical,
  faGripHorizontal,
  faList,
  faIndent,
  faLightbulbOn,
  faLightbulb,
  faBars,
  faXmark,
  faCircle,
  faClock,
  faComments,
  faFolder,
  faFolders,
  faFolderOpen,
  faFolderPlus,
  faCreditCardFront,
  faMagnifyingGlass,
  faLayerPlus,
  faUpload,
  faDropbox,
  faGoogleDrive,
  faLevelDown,
  faLevelUp,
  faDeleteLeft,
  faDiamond,
  farDiamond,
  farAngleDoubleLeft,
  farCube,
  farFrown,
  farGlobe,
  faCircleInfo,
  faSort,
  faDotCircle,
  faBolt,
  faInboxIn,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faExchange,
  faBuilding,
  faCar,
  faCalendarAlt,
  faFlag,
  faGlobeAmericas,
  faPresentation,
  faCubes,
  faAlignLeft,
  faTheaterMasks,
  faTv,
  faMusic,
  faCopy,
  faCreditCard,
  faMousePointer,
  faExpandArrows,
  faSlidersVSquare,
  farSlidersVSquare,
  farHeart,
  faMap,
  faWaveform,
  faEnvelope,
  faBorderAll,
  faCloudUpload,
  faListAlt,
  faBarsStaggered,
  faHardDrive,
  faShuffle,
  faICursor
)

Vue.component('fa-icon', FontAwesomeIcon)
